(ns bec-cljs-common.re-frame.events
  (:require [re-frame.core :as rf]
            [taoensso.timbre :as log]
            [bec-cljs-common.re-frame :as bec-rf]
            [bec-cljs-common.config :refer [app-server-url]]
            [bec-cljs-common.utils.common :refer [deep-merge]]))

(rf/reg-event-db :assoc-in ;; Only use for development
  (fn [db [_ path value]]
    (assoc-in db path value)))

(rf/reg-event-db :apply
  (fn [db [_ f & args]]
    (apply f db args)))

(rf/reg-event-db :run
  (fn [db [_ f]]
    (f db)))

(rf/reg-event-fx :dispatch-many
  (fn [_ [_ events]]
    {:fx events}))

(rf/reg-event-fx :set-theme
  (fn [_ [_ theme]]
    {:fx [[:set-theme theme]]}))

(rf/reg-event-fx :request-failure
  (fn [{:keys [db]} [_ request-type response error-modal-props]]
    (merge
      {:db (-> (assoc-in db [:responses request-type :failure] response)
             (assoc-in [:loading request-type] false))}
      (when error-modal-props
        {:fx [[:dispatch [:open-modal :error-modal
                          {:request-type request-type
                           :response response
                           :props error-modal-props}]]]}))))

(rf/reg-event-db :request-success
  (fn [db [_ request-type response]]
    (-> (assoc-in db [:loading request-type] false)
        (assoc-in [:responses request-type :success] response))))

(rf/reg-event-db :cleanup-request
  (fn [db [_ request-type]]
    (update-in db [:responses] dissoc request-type)))

(rf/reg-event-fx :reset!
  (fn [_ [_ a new-value]]
    {:fx [[:reset! [a new-value]]]}))

(rf/reg-event-fx :swap!
  (fn [_ [_ a function]]
    {:fx [[:swap! [a function]]]}))

(rf/reg-event-fx :local-storage
  (fn [_ [_ action k v]]
    {:fx [(case action
            :set-item [:local-storage [action k v]]
            :clear [:local-storage [action]]
            :remove-item [:local-storage [action k v]]
            nil)]}))

;; TODO: Remove
(rf/reg-event-fx :client-shared-state
  (fn [_ [_ path data]]
    {:fx [[:dispatch [::bec-rf/xhrio {:method :put, :uri (str app-server-url "/bec-clj-common/views")
                                      :event-key :client-shared-state
                                      :params {:path (into [:shared] path), :data data}}]]]}))
;; TODO: Remove
(rf/reg-event-fx :core-shared-state
  (fn [_ [_ path data]]
    {:fx [[:dispatch [::bec-rf/xhrio {:method :put, :uri (str app-server-url "/bec-core-client/shared-state")
                                      :event-key :core-shared-state
                                      :params {:path path, :data data}}]]]}))
